import { combineReducers } from 'redux';

import suggestedDomains from './suggestedDomains';

export default combineReducers({
  suggestedDomains
});